import "zurb-twentytwenty/js/jquery.event.move";
import "zurb-twentytwenty/js/jquery.twentytwenty";
import "zurb-twentytwenty/css/twentytwenty.css";

jQuery(document).ready(function($){
    $(window).on('load', function () {
        $(".twentytwenty > *").twentytwenty({
            default_offset_pct: 0.5, // How much of the before image is visible when the page loads
            orientation: 'horizontal', // Orientation of the before and after images ('horizontal' or 'vertical')
            before_label: 'Before', // Set a custom before label
            after_label: 'After', // Set a custom after label
            no_overlay: false, //Do not show the overlay with before and after
            move_slider_on_hover: false, // Move slider on mouse hover?
            move_with_handle_only: true, // Allow a user to swipe anywhere on the image to control slider movement.
            click_to_move: true // Allow a user to click (or tap) anywhere on the image to move the slider to that location.
        });

        $(document).on('move', '.twentytwenty-handle', function() {
            const $this = $(this);
            const $element = $this.closest('.twentytwenty');
            const $handle = $element.find('.twentytwenty-handle');
            const $before = $element.find('.twentytwenty-before-label');
            const $after = $element.find('.twentytwenty-after-label');
            $before.toggleClass('hidden', $handle.offset().left < $before.offset().left + $before.outerWidth() );
            $after.toggleClass('hidden', $handle.offset().left + $handle.outerWidth() > $after.offset().left );
        });
    });
});